import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../../common/PageTrackerHelper';
import { BasicSelect } from 'vue-search-select';

export default {
  name: 'RaiseDebit',
  components: {
    VueElementLoading,
    Paginate,
    BasicSelect,
  },
  mixins:[PageTracker],
  data: function() {
    return {
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      listtype: '',
      clientid: '',
      hubzoneid: '',
      hubname: '',
      notifystatus: 'MarkLost',
      amount:'',
      amountcomparator:'',
      netpayment:'',
      gapdays:'',
      gapdayscomparator:'',
      txtgapdays:'',
      clientList: [],
      hubZoneList:[],
      hubServiceCenterList:[],
      listRaiseDebitData:[],
      listRaiseDebitDataCSV:[],
      shipmentLogList: [],
      pageno: 0,
      pagecount: 0,
      perpage:50,
      shipmentlogmodal: false,
      isLoading: false,
      localhubdetails:'',
      localuserid:'',
      localhubdetails:'',
      resultCount:0,
      clientItemObj: { value: '', text: '' },
      srLoader: "",
      defaultHhub: {HubID: '', HubName: ''},
      zone_obj: {hubzoneid: '', hubzonename: ''},
      hubinfo: {},
      totalRecords:0,
      value: 0,
      last_value: 0,
      validation: {
        min: 0,
        max: 10000000000000,
        decimal: 100
      },
      Vertical : '',
      awbnumbers: '',
      ShippingID: [],
      form: {
        shippingidchk: [],
        values: [],
        checkboxval: []
      },
      totalSelectedRecords: 0,
      userDataKey : '',
      notifystatus: "MarkLost",
      loggedInuserdetails: [],
      isLostNewFeaturesisOnThisHub: '',
      checkbox: '',
      form: {
        shippingidchk: [],
      },
      firstNotifyGapDays: null,
      errorMessage: '',
      selectAllchk: false
    }
  },
  created: function() {
  },
  computed: {
    isAllSelected() {
       return (
        this.listRaiseDebitData.length > 0 &&
        this.form.shippingidchk.length === this.listRaiseDebitData.length &&
        this.form.shippingidchk.length > 0 &&
        this.listRaiseDebitData.every(function(item) {
          return item.NotifyGapDays === this.form.shippingidchk[0].NotifyGapDays;
        }.bind(this))
      );
    }
  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.loggedInuserdetails = userdetail
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubname = this.localhubdetails;
    //console.log("this.localhubdetails",this.localhubdetails);
    this.getClientData();
    this.getHubZoneData();
    this.getHubServiceCenterData();
    this.getRaiseDebitData();

    //console.log('Mixin is working for :',result);
    this.hubinfo  = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    this.defaultHhub.HubID = this.hubinfo.HubID
    this.defaultHhub.HubName = this.hubinfo.HubName
    this.zone_obj.hubzoneid = this.hubinfo.HubZoneId
    this.zone_obj.hubzonename = this.hubinfo.hubzonename
    this.hubzoneid = this.hubinfo.HubZoneId
    let isLostNewFeatures = await this.getDataFromRedisbyKeyNameCommonFun({
      "key": "newLostDebitUserRestrictionHubLevelConfig"
    })
    this.isLostNewFeaturesisOnThisHub = isLostNewFeatures.includes(0) || isLostNewFeatures.includes(this.hubinfo.HubID) ? true : false;
  },
  methods: {

    validateForm(scope) {
      this.$validator.validateAll(scope).then( async result => {
        if(result){
          if( this.isLostNewFeaturesisOnThisHub ) {
            let getresponse =  await this.ValidateLostAuthAccess(this.loggedInuserdetails)
            console.log(getresponse, "Raisedebit page.");
            if(!getresponse) {
              return false;
            }
          }
          let shipmentArr = []
          if (this.form.shippingidchk.length == 0) {
            this.$alertify.error("Please select shipment(s)!");
          } else {
            this.isLoading = true;
            this.form.shippingidchk.forEach((item) => {
              shipmentArr.push(item.ShippingID.toString());
            });
            this.redirectHubMarkLostDebit(shipmentArr)
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },

    redirectHubMarkLostDebit(shipmentArr){
      let finalShippingids = JSON.stringify(shipmentArr)
      this.$router.push({
        name: 'Hub Mark LostDebit',
        path: '/HubMarkLostDebit',
        query: { shippingid: finalShippingids },
        component: 'HubMarkLostDebit'
      });
    },

    closeShipmentLogModal() {
      this.shipmentlogmodal = false,
      this.$validator.reset();
      this.errors.clear();
    },

    getclientsObj(obj) {
      this.clientItemObj = obj
      this.clientid = obj.value
    },

    //to get client list
    getClientData() {
      this.srLoader = this.loader;
      axios.get(apiUrl.api_url + 'external/getclientlist', {})
        .then((response) => {
          if (response.data.code === 200) {
            this.clientArrayList = response.data.data;
            for (let i = 0; i < this.clientArrayList.length; i++) {
              this.clientList.push({
                value: this.clientArrayList[i].ClientMasterID,
                text: `${this.clientArrayList[i].CompanyName}`
              })
            }
          }
          else {
            this.clientList = [];
          }
          this.srLoader = "";
        })
        .catch((httpException) => {
          this.$alertify.error("client data not found");
          console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Zone list
    getHubZoneData() {
      axios.get(apiUrl.api_url + 'external/gethubzonelist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubZoneList=response.data.data;
            }
            else {
                this.hubZoneList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Hub Zone data not found");
              console.error('exception is:::::::::', httpException)
        })
    },
    //to get Zone wise Hub Service Center list
    getZoneHubServiceCenterData() {
      if(this.hubzoneid==0){
        return false;
      }
      axios.get(apiUrl.api_url + 'external/getzonewisehublist?zoneid='+this.hubzoneid, {})
        .then((response) => {
            if(response.data.code===200){
                this.hubname='';
                this.hubServiceCenterList=response.data.data;
                this.hubServiceCenterList.sort(function(a, b){
                 var nameA=a.HubName.toLowerCase(), nameB=b.HubName.toLowerCase()
                 if (nameA < nameB) //sort string ascending
                  return -1
                 if (nameA > nameB)
                  return 1
                 return 0 //default return value (no sorting)
                });
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Hub Service Center data not found");
              console.error('exception is:::::::::', httpException)
        })
    },

    //to get Hub Service Center list
    getHubServiceCenterData() {
      axios.get(apiUrl.api_url + 'external/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.hubServiceCenterList=response.data.data;
            }
            else {
                this.hubServiceCenterList=[];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Hub Service Center data not found");
              console.error('exception is:::::::::', httpException)
        })

    },

    //to get pagination
    getPaginationData(pageNum) {
        this.pageno = pageNum;
        this.getRaiseDebitData();
    },

    //search Raise Debit data
    searchRaiseDebitData(){
      this.pageno = 1;
      this.$refs.paginate.selected= 0;
      this.getRaiseDebitData();
    },
    changeDateFormat(inputString){
      let current_datetime = new Date(inputString)
      let formatted_date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear();
      return formatted_date;
    },
    //to get Raise Debit Data
    getRaiseDebitData() {
      this.form.shippingidchk = [];
      this.form.values = [];
      this.form.checkboxval = [];
      this.checkbox = false;
      this.totalSelectedRecords = this.form.shippingidchk.length;
      if (this.awbnumbers.length>0) {
        let shippingId=this.awbnumbers.split(/[\s,]+/);
        let shipmentReqArray = [];
        $.each(shippingId, (key,shipmentId)=>{
          if(shipmentId != ''){
            shipmentReqArray.push(shipmentId.trim())
          }
        })
          if(shipmentReqArray.length > 50){
            this.$alertify.error("Maximum 50 shippingID you can enter.")
          }else{
            this.ShippingID = shipmentReqArray;
          }
      }
        this.input = ({
            ListType: this.listtype,
            ClientID: this.clientid,
            HubZoneId: this.hubzoneid,
            HubId: this.hubname,
            NotifyStatus: this.notifystatus,
            AmountType: this.amount,
            AmountCompare: this.amountcomparator,
            Amount: this.netpayment,
            GapDaysType: this.gapdays,
            GapDays: this.txtgapdays,
            GapDaysCompare: this.gapdayscomparator,
            offset: this.pageno,
            limit: this.perpage,
            exportFlag:"0",
            Vertical: 'B2C',
            ShippingId:this.ShippingID
        })
        this.isLoading = true;
        axios({
                method: 'POST',
                'url': apiUrl.api_url + 'shipmentLost/getLostNotifiedList',
                'data': this.input
            })
            .then(result => {
                let debitData = result.data.data;
                let temparr = [];
                let temparrCSV = [];
                if(debitData!=null){
                  debitData.forEach((debit)=>{
                    var newcreateddate = this.changeDateFormat(debit.CreatedDate);
                      temparr.push({"ClientName":debit.ClientName,
                                 "NotifyNoInfoShipmentsID":debit.NotifyNoInfoShipmentsID,
                                 "ShippingID":debit.ShippingID,
                                 "NetPayment":debit.NetPayment,
                                 "OctroiMRP":debit.OctroiMRP,
                                 "NotifyStatus":debit.NotifyStatus,
                                 "Status":debit.Status,
                                 "ShipmentStatus":debit.ShipmentStatus,
                                 "CurrentHubName":debit.CurrentHubName,
                                 "OriginHubName":debit.OriginHubName,
                                 "FinalDestinationName":debit.FinalDestinationName,
                                 "NotifyGapDays":debit.NotifyGapDays,
                                 "ShipmentGapDays":debit.ShipmentGapDays,
                                 "CreatedDate":newcreateddate,
                                 "CreatedBy":debit.CreatedBy,
                               });
                       temparrCSV.push({"ClientName":debit.ClientName,
                                    "ShippingID":debit.ShippingID,
                                    "NetPayment":debit.NetPayment,
                                    "OctroiMRP":debit.OctroiMRP,
                                    "NotifyStatus":debit.NotifyStatus,
                                    "Status":debit.Status,
                                    "ShipmentStatus":debit.ShipmentStatus,
                                    "CurrentHubName":debit.CurrentHubName,
                                    "OriginHubName":debit.OriginHubName,
                                    "FinalDestinationName":debit.FinalDestinationName,
                                    "NotifyGapDays":debit.NotifyGapDays,
                                    "ShipmentGapDays":debit.ShipmentGapDays,
                                    "CreatedDate":newcreateddate,
                                    "CreatedBy":debit.CreatedBy,
                                  });
                  });
                }
                this.listRaiseDebitData = temparr;
                this.listRaiseDebitDataCSV = temparrCSV;
                this.isLoading = false;
                let totalRows = 0;
                if(result.data.totalCount!=undefined){
                  totalRows = result.data.totalCount;
                }
                this.resultCount = totalRows;
                this.totalRecords = totalRows
                if (totalRows < this.perpage) {
                    this.pagecount = 1
                } else {
                    this.pagecount = Math.ceil(totalRows / this.perpage)
                }
            }, error => {
                console.error(error)
            })
    },

    //to get Shipment Log
    getShipmentLogData(ShippingID) {

      this.$validator.reset();
      this.errors.clear();

      axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${ShippingID}`)
        .then((response) => {
            this.shipmentlogmodal = true;
            if(response.data.code===200){
                this.shipmentLogList = response.data.data;
            }
            else {
                this.shipmentLogList = [];
            }
        })
        .catch((httpException) => {
              this.$alertify.success("Shpment Log data not found");
              console.error('exception is:::::::::', httpException)
        })

    },

    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          this.searchRaiseDebitData(event);
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    exportForm(){
      if(this.listRaiseDebitDataCSV==undefined || this.listRaiseDebitDataCSV.length==0){
        this.$alertify.alert("No data","No data available for download.");
      }
      this.input = ({
          ListType: this.listtype,
          ClientID: this.clientid,
          HubZoneId: this.hubzoneid,
          HubId: this.hubname,
          NotifyStatus: this.notifystatus,
          AmountType: this.amount,
          AmountCompare: this.amountcomparator,
          Amount: this.netpayment,
          GapDaysType: this.gapdays,
          GapDays: this.txtgapdays,
          GapDaysCompare: this.gapdayscomparator,
          offset: this.pageno,
          limit: this.perpage,
          exportFlag:"1",
          Vertical: this.Vertical,
          ShippingId:this.ShippingID
      })
      this.isLoading = true;
      axios({
              method: 'POST',
              'url': apiUrl.api_url + 'shipmentLost/getLostNotifiedList',
              'data': this.input
          })
          .then(result => {
              let debitData = result.data.data;
              let temparrCSV = [];
              // console.log("debitData====",debitData);
              if(debitData!=null){
                debitData.forEach((debit)=>{
                  var newcreateddate = this.changeDateFormat(debit.CreatedDate);
                     temparrCSV.push({"ClientName":debit.ClientName,
                                  "ShippingID":debit.ShippingID,
                                  "NetPayment":debit.NetPayment,
                                  "OctroiMRP":debit.OctroiMRP,
                                  "NotifyStatus":debit.NotifyStatus,
                                  "Status":debit.Status,
                                  "ShipmentStatus":debit.ShipmentStatus,
                                  "CurrentHubName":debit.CurrentHubName,
                                  "OriginHubName":debit.OriginHubName,
                                  "FinalDestinationName":debit.FinalDestinationName,
                                  "NotifyGapDays":debit.NotifyGapDays,
                                  "ShipmentGapDays":debit.ShipmentGapDays,
                                  "CreatedDate":newcreateddate,
                                  "CreatedBy":debit.CreatedBy,
                                });
                });
              }
              this.listRaiseDebitDataCSV = temparrCSV;
              this.isLoading = false;
              // console.log("this.listRaiseDebitDataCSV========",this.listRaiseDebitDataCSV);
              this.getDownloadCsvObject(this.listRaiseDebitDataCSV);
          }, error => {
              console.error(error)
          })
    },
    getDownloadCsvObject(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "ProcessNotifyLostShipment_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    convertArrayOfObjectsToCSV: function(args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      keys = Object.keys(data[0]).slice(0);
      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;
          if (item[key] != null) {
            result += '"' + item[key] + '"';
          }
          ctr++;
        });
        result += lineDelimiter;
      });
      return result;
   },
    resetForm() {
      this.awbnumbers = '',
        this.ShippingID = [],
        this.Vertical = '';
        this.clientid = '';
        this.clientItemObj = {}
        // this.hubzoneid = '';
        // this.hubname = this.localhubdetails;
        this.amount = '';
        this.amountcomparator = '';
        this.netpayment = '';
        this.gapdays = '';
        this.txtgapdays = '';
        this.gapdayscomparator = '';
        this.pageno = 1;
        this.$refs.paginate.selected= 0;
        this.listtype = '';
        // this.hubzoneid = '';
        this.defaultHhub.HubID = this.hubinfo.HubID
        this.defaultHhub.HubName = this.hubinfo.HubName
        this.zone_obj.hubzoneid = this.hubinfo.HubZoneId
        this.zone_obj.hubzonename = this.hubinfo.hubzonename
        this.hubzoneid = this.hubinfo.HubZoneId
        this.getHubServiceCenterData();
        this.getRaiseDebitData();
    },
    format_number(e) {
      if (e > this.validation.max) {
        return this.validation.max
      } else if (e < this.validation.min) {
        return this.validation.min
      } else if (Math.round(e * this.validation.decimal) / this.validation.decimal != e) {
        return this.last_value
      } else {
        this.last_value = e
        return e
      }
    },
    onlyNumber : function($event){
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      console.log("keycode======",keyCode);
       if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44 && keyCode == 190) {
          $event.preventDefault();
       }
    },
    // calculateselectedcount() {
    //   this.totalSelectedRecords = this.form.shippingidchk.length
    // },
    calculateselectedcount(event, currentItem) {
      if(this.isLostNewFeaturesisOnThisHub){
        this.totalSelectedRecords = this.form.shippingidchk.length;

        if (this.form.shippingidchk.length === 0) {
          this.firstNotifyGapDays = null;
          this.errorMessage = '';
          return;
        }

        var firstGap = this.form.shippingidchk[0].NotifyGapDays;

        var allSame = this.form.shippingidchk.every(function(item) {
          return item.NotifyGapDays === firstGap;
        });

        if (!allSame) {
          // Deselect visually if checkbox was just checked
          if (event && event.target && event.target.checked) {
            event.target.checked = false;
          }

          // Remove only invalid entries
          this.form.shippingidchk = this.form.shippingidchk.filter(function(item) {
            return item.NotifyGapDays === firstGap;
          });

          this.totalSelectedRecords = this.form.shippingidchk.length;
          this.errorMessage = 'Please select same day lost notify aging days shipments for raise debit.';

          setTimeout(() => {
            this.errorMessage = '';
          }, 5000);
        } else {
          this.firstNotifyGapDays = firstGap;
          this.errorMessage = '';
        }
      } else{
        this.totalSelectedRecords = this.form.shippingidchk.length
      }
    },
    // selectItems(ev) {
    //   this.form.shippingidchk = [];
    //   if (ev.target.checked == true) {
    //     this.listRaiseDebitData.map(obj => {
    //       this.form.shippingidchk.push(obj)
    //     })
    //   } else {
    //     this.listRaiseDebitData.map(obj => {
    //       this.form.shippingidchk.pop(obj)
    //     })
    //   }
    // }
    selectItems(ev) {
      if(this.isLostNewFeaturesisOnThisHub){
        const isTryingToSelectAll = ev.target.checked;
        if (isTryingToSelectAll) {
          if (this.listRaiseDebitData.length === 0) {
            this.errorMessage = 'No rows to select';
            setTimeout(() => {
              this.errorMessage = '';
              ev.target.checked= false
            }, 5000);
            return;
          }

          const firstNotifyGapDays = this.listRaiseDebitData[0].NotifyGapDays;

          const allSame = this.listRaiseDebitData.every(
            (item) => item.NotifyGapDays === firstNotifyGapDays
          );

          if (allSame) {
            this.form.shippingidchk = [...this.listRaiseDebitData]; // select all
            this.firstNotifyGapDays = firstNotifyGapDays;
            this.errorMessage = '';
          } else {
            // Do NOT update form.shippingidchk => checkbox stays unchecked (via isAllSelected)
            this.errorMessage = 'Please select same day lost notify aging days shipments for raise debit.';
            setTimeout(() => {
              this.errorMessage = '';
              ev.target.checked= false
            }, 5000);
            
          }
        } else {
          // Deselect all
          this.form.shippingidchk = [];
          this.firstNotifyGapDays = null;
          this.errorMessage = '';
        }

      } else{
        this.form.shippingidchk = [];
        if (ev.target.checked == true) {
          this.listRaiseDebitData.map(obj => {
            this.form.shippingidchk.push(obj)
          })
        } else {
          this.listRaiseDebitData.map(obj => {
            this.form.shippingidchk.pop(obj)
          })
        }
      } 
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/RaiseDebit/RaiseDebit.component.js